import React from 'react';

const MenuUniformesTallas = ({link}) => {

    return (
        <></>
    );
}

export default MenuUniformesTallas;